export default __webpack_public_path__ + "static/media/File No. 7.5555691c.pdf";